















































import V3Banner from '../components/V3Banner.vue';

export default {
	name: 'Dashboard',
	components: {
		V3Banner,
	},
	computed: {
		metrics(): Object {
			return this.$store.state.metrics;
		},
		organization() {
			return this.$store.state.organization;
		},
		expired(): Boolean {
			return this.$store.getters.isExpired;
		},
		apps(): { labels: string[]; values: number[] } {
			return this.$store.getters.apps;
		},
		platforms(): { labels: string[]; values: number[] } {
			return this.$store.getters.platforms;
		},
	},
};
